import { z } from 'zod';

export const legalFeeItemConfigSchema = z.object({
  title: z.string().min(1).max(255),
  currency: z.string().min(3).max(3),
  amount: z.number().min(0).max(999_999_999.99),
  description: z.string().max(1000).nullable().optional(),
});

export const itemPaymentFormSchema = z.object({
  account_id: z.string().uuid('Select a debit account'),
  amount: z.number().min(0.01).max(999_999_999.99),
  payment_date: z
    .string()
    .min(1)
    .refine((d) => d <= new Date().toISOString().split('T')[0], {
      message: 'Payment date cannot be in the future',
    }),
  notes: z.string().max(500).nullable().optional(),
});
export type ItemPaymentFormData = z.infer<typeof itemPaymentFormSchema>;

export const stagePaymentFormSchema = z.object({
  account_id: z.string().uuid('Select a debit account'),
  total_amount: z.number().min(0.01), // upper bound validated at runtime against unpaid sum
  payment_date: z
    .string()
    .min(1)
    .refine((d) => d <= new Date().toISOString().split('T')[0], {
      message: 'Payment date cannot be in the future',
    }),
  notes: z.string().max(500).nullable().optional(),
});
export type StagePaymentFormData = z.infer<typeof stagePaymentFormSchema>;

export const editItemFormSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255),
  currency: z.string().min(3).max(3),
  amount: z.number().min(0).max(999_999_999.99),
  description: z.string().max(1000).nullable().optional(),
});
export type EditItemFormData = z.infer<typeof editItemFormSchema>;
